import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthError, ConfirmSignUpInput } from 'aws-amplify/auth';
import { NgOtpInputModule } from 'ng-otp-input';
import { CognitoService } from '../../services/cognito.service';
import { Router } from '@angular/router';
import { NotificationService } from '../../services/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirmation',
  standalone: true,
  imports: [NgOtpInputModule, CommonModule],
  templateUrl: './confirmation.component.html',
})
export class ConfirmationComponent implements OnInit {

  form!: UntypedFormGroup;
  wrongcode = false;
  username: any;
  loading = false;

  constructor(private formBuilder: UntypedFormBuilder, public cognitoService: CognitoService,
    public router: Router, private notificationService: NotificationService, private traslateService: TranslateService) { }

  ngOnInit(): void {
    this.username = localStorage.getItem("username");

    /**
    * Form Validatyion
    */
    this.form = this.formBuilder.group({
      code: ['', [Validators.required]],
    });
  }

  onOtpChange(otp: any) {
    this.wrongcode = false;
    this.form.controls['code'].setValue(otp);
  }

  async resendCode() {
    this.loading = true;
    await this.cognitoService.handleResendSignUpCode(this.username!);
    this.loading = false;
  }

  async next() {
    if (this.form.invalid || this.form.controls['code'].value!.length < 6) {
      const title = await this.traslateService.get('NOTIFI.titleError').toPromise();
      const detail = await this.traslateService.get(`ERRORS.errorCodeVerification`).toPromise();
      this.notificationService.showError(title, detail)
      return;
    }
    this.loading = true;
    try {
      const confirmSignUp: ConfirmSignUpInput = { username: this.username!, confirmationCode: this.form.controls['code'].value! };
      await this.cognitoService.handleSignUpConfirmation(confirmSignUp);
      localStorage.removeItem("username");
      const title = await this.traslateService.get('NOTIFI.titleSuccess').toPromise();
      const detail = await this.traslateService.get(`NOTIFI.detailAccountVerified`).toPromise();
      this.notificationService.showSuccess(title, detail)
      this.loading = false;
      this.router.navigateByUrl("/account-login");
    } catch (error) {
      if (error instanceof AuthError) {
        switch (error.name) {
          case "CodeMismatchException":
            const title = await this.traslateService.get('NOTIFI.titleError').toPromise();
            const detail = await this.traslateService.get(`ERRORS.errorCodeInvalid`).toPromise();
            this.notificationService.showWarning(title, detail)
            break
          default:
            const detailB = await this.traslateService.get(`ERRORS.Error`).toPromise();
            this.notificationService.showError(title, detailB)
            break
        }
      } else {
        const title = await this.traslateService.get('NOTIFI.titleError').toPromise();
        const detail = await this.traslateService.get(`ERRORS.Error`).toPromise();
        this.notificationService.showError(title, detail)
      }
      this.loading = false;
    }
  }

}
